<template>
  <div class="main-wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-catering">
      <el-tab-pane label="使用者管理" name="first" v-if="$isPermission('agencyAdmin.list')">
        <div class="container">
            <user v-if="activeName == 'first'"></user>
        </div>
      </el-tab-pane>
      <el-tab-pane label="房間設定" name="second">
        <div class="container">
           <room v-if="activeName == 'second'"></room>
        </div>
      </el-tab-pane>


      <el-tab-pane label="權限等級" name="third" v-if="$isPermission('agencyRole.list')">
        <div class="container">
          <roles v-if="activeName == 'third'"></roles>
        </div>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>

export default {
  name: "System",
  components:{
     user: () => import('@/views/System/user.vue'),
    room: () => import('@/views/System/room.vue'),
    roles: () => import('@/views/role/roles.vue')
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  created() {

  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods:{
     handleClick(){

     }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
</style>
